import React from "react";

const ImportSteps = ( {data} ) => {
    return(
        <div className="flex flex-col gap-8 leading-tight">
            {
                data.importsteps.map((importsteps, index) => (
                    <>
                        <span className="font-medium md:text-[40px] text-[28px]" style={{color: data.importsteps.title_color}}>
                            {importsteps.title}
                        </span>
                        <div className="flex flex-col gap-3">
                            {
                                importsteps.card.map((card,index) => (
                                    <div key={index} className="grid lg:grid-cols-[0.5fr_4fr_2fr] md:grid-cols-[0.5fr_3fr_2fr] grid-cols-1 
                                            md:gap-10 gap-4 md:p-6 p-5 rounded-3xl" style={{backgroundColor: card.bg}}
                                        >
                                        <span className="md:text-[20px] text-[16px] font-medium" style={{color: card.step_color}}>
                                            {card.step}
                                        </span>
                                        <div className="flex flex-col gap-5 font-medium">
                                            <span className="lg:text-[28px] md:text-[24px] text-[20px]" style={{color: card.big_text_color}}>
                                                {card.big_text}
                                            </span>

                                            <span className="lg:text-[20px] text-[16px]" style={{color: card.meduim_text_color}}>
                                                {card.meduim_text}
                                            </span>

                                            <span className="text-[14px] lg:w-[60%] md:w-full text-balance" style={{color: card.small_text_color}}>
                                                {card.small_text}
                                            </span>
                                        </div>
                                        <img className="flex rounded-2xl w-full" src={card.image} alt=""/>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                ))
                
            }
        </div>
    );
};
export default ImportSteps;